/** Демо-данные отзывов (формат как у API). Позже заменить на store/API. */
export const DEMO_REVIEWS = [
  {
    id: 'demo-1',
    name: 'Екатерина К.',
    date: '2025-05-12',
    review:
      'Благодарность всему родовому отделению! Врачи и акушерки были рядом на каждом этапе. Чувствовали заботу и профессионализм. Рекомендую центр всем будущим мамам.',
    rating: 5,
    categories: ['О родах'],
    published: true,
  },
  {
    id: 'demo-2',
    name: 'Анна Н.',
    date: '2025-05-10',
    review:
      'Наблюдалась по беременности в консультации центра. Всё четко, понятно, без лишней тревоги. Отдельное спасибо за внимательность на приёмах.',
    rating: 5,
    categories: ['О беременности'],
    published: true,
  },
  {
    id: 'demo-3',
    name: 'Мария П.',
    date: '2025-05-06',
    review:
      'Хочу отметить работу врача Волкова Д.И. Профессионал своего дела, всё по факту, без лишних назначений. Очень благодарна!',
    rating: 5,
    categories: ['О врачах'],
    published: true,
  },
  {
    id: 'demo-4',
    name: 'Ольга С.',
    date: '2025-04-28',
    review:
      'После родов малыша перевели в неонатологию. Персонал объяснял каждый шаг, поддерживал. Спокойствие врачей передалось и нам.',
    rating: 5,
    categories: ['О неонатологии'],
    published: true,
  },
  {
    id: 'demo-5',
    name: 'Ирина В.',
    date: '2025-04-20',
    review:
      'Роды прошли спокойно благодаря команде дежурной бригады. Чистота, порядок, человеческое отношение — спасибо огромное!',
    rating: 4,
    categories: ['О родах', 'О врачах'],
    published: true,
  },
  {
    id: 'demo-6',
    name: 'Светлана Д.',
    date: '2025-04-15',
    review:
      'Проходила обследования перед госпитализацией. Всё организовано удобно, очередей почти не было. Персонал вежливый.',
    rating: 5,
    categories: ['О беременности'],
    published: true,
  },
  {
    id: 'demo-7',
    name: 'Наталья М.',
    date: '2025-04-02',
    review:
      'Благодарим отделение неонатологии за заботу о нашем малыше. Видно, что работают с душой и большой ответственностью.',
    rating: 5,
    categories: ['О неонатологии'],
    published: true,
  },
  {
    id: 'demo-8',
    name: 'Елена Р.',
    date: '2025-03-25',
    review:
      'Хочу поблагодарить врача за внимательное ведение беременности. Всегда была на связи, отвечала на вопросы спокойно и по делу.',
    rating: 5,
    categories: ['О врачах', 'О беременности'],
    published: true,
  },
]

export const REVIEW_FAQ = [
  {
    id: 'when',
    question: 'Когда публикуются отзывы?',
    answer:
      'Отзывы появляются на сайте после проверки модератором. Обычно это занимает от одного до нескольких рабочих дней.',
  },
  {
    id: 'anon',
    question: 'Можно ли оставить отзыв анонимно?',
    answer:
      'Вы можете указать имя в удобной форме (например, только имя или инициалы). Полные паспортные данные для публикации отзыва не требуются.',
  },
  {
    id: 'why-not',
    question: 'Почему мой отзыв не опубликован?',
    answer:
      'Отзыв могут не опубликовать, если он содержит оскорбления, персональные данные третьих лиц, рекламу или не относится к работе центра. Мы также проверяем отзывы на соответствие правилам публикации.',
  },
  {
    id: 'check',
    question: 'Как мы проверяем отзывы?',
    answer:
      'Модераторы читают каждый отзыв перед публикацией: оценивают корректность формулировок и соответствие правилам. Публикуются только проверенные сообщения пациентов и их семей.',
  },
]
